import React, { useState } from 'react';
import './OptimizedImage.css';

const OptimizedImage = ({ 
  src, 
  alt, 
  sizes = '100vw',
  className = '',
  loading = 'lazy',
  onError,
  ...props 
}) => {
  const [imageError, setImageError] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);

  // Tenta WebP primeiro, fallback para PNG/JPG
  const getImageSrc = (extension = 'png') => {
    // Se já houve erro, tenta fallback
    if (imageError && extension !== 'png') {
      return src.replace(/\.(webp|png|jpg|jpeg)$/i, `.${extension}`);
    }
    // Tenta WebP primeiro se não houve erro
    if (!imageError) {
      if (src.includes('.')) {
        return src.replace(/\.(png|jpg|jpeg)$/i, '.webp');
      }
      return `${src}.webp`;
    }
    // Fallback para PNG
    if (src.includes('.')) {
      return src.replace(/\.(webp|jpg|jpeg)$/i, '.png');
    }
    return `${src}.png`;
  };

  const handleError = (e) => {
    if (!imageError) {
      setImageError(true);
      // Tenta fallback para PNG
      e.target.src = getImageSrc('png');
    } else if (onError) {
      onError(e);
    }
  };

  const handleLoad = () => {
    setImageLoaded(true);
  };

  return (
    <div className={`optimized-image-wrapper ${className}`}>
      {!imageLoaded && (
        <div className="image-placeholder">
          <div className="image-skeleton"></div>
        </div>
      )}
      <img
        src={getImageSrc()}
        alt={alt || ''}
        sizes={sizes}
        loading={loading}
        onError={handleError}
        onLoad={handleLoad}
        className={`optimized-image ${imageLoaded ? 'loaded' : ''}`}
        {...props}
      />
    </div>
  );
};

export default OptimizedImage;
